import { AssemblyIndustry } from '@luminovo/api-contracts';
import { Tag } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';
import type { JSX } from 'react';

import { assemblyIndustryTranslations } from '../../i18n';

export const IndustryTag = ({ industry }: { industry: AssemblyIndustry }): JSX.Element => {
    return <Tag attention={'low'} color="primary" label={transEnum(industry, assemblyIndustryTranslations)} />;
};
